import AppCardCustom from "@/components/AppCardCustom";
import PpcBudgetAllocationHeader from "@/components/PpcBudgetAllocationHeader";
import PpcBudgetAllocationItem from "@/components/PpcBudgetAllocationItem";
export default {
  name: "PpcBudgetAllocation",
  emits: ["item-update"],
  components: {
    AppCardCustom,
    PpcBudgetAllocationHeader,
    PpcBudgetAllocationItem
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    currency: {
      type: String
    },
    selected_profile_id: {
      type: String
    },
    selected_seller: {
      type: Object
    },
    still_initializing: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      mode: "acos",
      search: "",
      weeklyBudgetTarget: null
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter(this.itemsFilter).sort((a, b) => {
        return b.sponsored_net_profit * 1 > a.sponsored_net_profit * 1 ? 1 : b.sponsored_net_profit * 1 < a.sponsored_net_profit * 1 ? -1 : 0;
      }).sort((a, b) => {
        return b.is_enabled * 1 > a.is_enabled * 1 ? 1 : b.is_enabled * 1 < a.is_enabled * 1 ? -1 : 0;
      });
    }
  },
  methods: {
    onItemUpdate(item) {
      this.$emit("item-update", item);
    },
    onWeeklyBudgetEdit(target) {
      this.weeklyBudgetTarget = target;
    },
    itemsFilter(item) {
      const campaignGroupName = item.campaign_group_name.toLowerCase();
      const asinListConcat = item.asin_group.join("_").toLowerCase();
      const asinNamesConcat = item.campaign_group_details.reduce((acc, cur) => {
        return acc += cur?.asin_name ?? '' + '_';
      }, '').toLowerCase();
      const skusConcat = item.skus?.join('_').toLowerCase();
      return campaignGroupName?.includes(this.search.toLowerCase()) || asinListConcat?.includes(this.search.toLowerCase()) || asinNamesConcat?.includes(this.search.toLowerCase()) || skusConcat?.includes(this.search.toLowerCase());
    }
  }
};